import { render, staticRenderFns } from "./changeChannel.vue?vue&type=template&id=7ff4dfbd&scoped=true&"
import script from "./changeChannel.vue?vue&type=script&lang=js&"
export * from "./changeChannel.vue?vue&type=script&lang=js&"
import style0 from "./changeChannel.vue?vue&type=style&index=0&id=7ff4dfbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4dfbd",
  null
  
)

export default component.exports